import { BaseSectionTitlePlugin } from './base';
import { Dropdown, type DropdownData, type DropdownProps } from '../../Dropdown/Dropdown';

type CustomDropdownProps = Pick<DropdownProps, 'horizontal'>;

/**
 * DropdownPlugin
 * @see{Dropdown}
 * - SectionTitle 에서 사용되는 드롭다운 플러그인
 * - 기본 뷰 데이터: 빈 옵션 리스트
 * - 기본 드롭다운 옵션: horizontal 방향 'left'
 */
export class DropdownPlugin extends BaseSectionTitlePlugin<
  DropdownData<string>,
  Partial<DropdownData<string>>
> {
  ViewClass = Dropdown<string>;
  default_view_data: DropdownData<string> = {
    options: [],
  };

  private default_dropdown_options: DropdownProps = {
    horizontal: 'left',
  };

  private custom_dropdown_options?: DropdownProps = {
    horizontal: 'left',
  };

  constructor(custom_view_data?: Partial<DropdownData<string>>, dropdown_options?: CustomDropdownProps) {
    super();
    this.custom_view_data = custom_view_data;
    this.custom_dropdown_options = dropdown_options;
  }

  private makeDropDownOptions = (custom_dropdown_options?: CustomDropdownProps): DropdownProps => {
    if (custom_dropdown_options) {
      return {
        ...this.default_dropdown_options,
        ...custom_dropdown_options,
      };
    }
    return this.default_dropdown_options;
  };

  override makeViewInstance = (
    custom_view_data = this.custom_view_data,
    custom_dropdown_options = this.custom_dropdown_options,
  ) => {
    return new this.ViewClass(
      this.makeViewData(custom_view_data),
      this.makeDropDownOptions(custom_dropdown_options),
    );
  };
}
